import i18n from '../../../utils/i18n';

export const CHART_TYPE = {
	BUBBLE: 'BUBBLE',
	COLUMN: 'COLUMN'
};

export const CHARTS_TRANSLATION_STRINGS = {
	noProducts: i18n.t('components.quickFilters.charts.noProducts'),
	notAllData: i18n.t('components.quickFilters.charts.notAllData'),
	bubbleTooltip: i18n.t('components.quickFilters.charts.bubble.tooltipText')
};
